import script from "./SectionCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionCounter.vue?vue&type=script&setup=true&lang=js"

import "./SectionCounter.vue?vue&type=style&index=0&id=343725e5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-343725e5"]])

export default __exports__